import type { ComponentProps } from 'react';

import { clsxm } from '@vs-shop/utils';

export const IconChevronSend = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg
    data-slot="icon-chevron-send"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    className={clsxm('text-foreground size-6', className)}
    {...props}
  >
    <path d="M3 20V14L11 12L3 10V4L22 12L3 20Z" fill="currentColor" />
  </svg>
);
